import React from "react";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce(
      (total, item) => total + Number(item[field] || 0),
      0,
    );
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.National:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Wilayah</th>
                <th>Melaporkan (1=Lapor)</th>
                <th>Jum CC</th>
                <th>Jum CC memiliki SK</th>
                <th>Jum CC PNS</th>
                <th>Jum CC ATLM</th>
                <th>Jum CC terlatih</th>
                <th>Jum CC belum terlatih</th>
                <th>Jum CC diketahui kompetensinya yg memenuhi syarat</th>
                <th>Jum CC diketahui kompetensinya yg belum memenuhi syarat</th>
                <th>Jum CC tidak diketahui kompetensinya</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.wilayah}</td>
                    <td>{item?.propmelapor2bc}</td>
                    <td>{item?.jumcc}</td>
                    <td>{item?.jumccsk}</td>
                    <td>{item?.jumccpns}</td>
                    <td>{item?.jumccatlm}</td>
                    <td>{item?.mikrosterlatih}</td>
                    <td>{item?.mikrosbelumterlatih}</td>
                    <td>{item?.sesuaisyarat}</td>
                    <td>{item?.tdksesuaisyarat}</td>
                    <td>{item?.jumcctdkdiketkompetensinya}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={34}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>

                <td style={{ color: "#FFF" }}>{getTotal("propmelapor2bc")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("jumcc")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("jumccsk")}</td>

                <td style={{ color: "#FFF" }}>{getTotal("jumccpns")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("jumccatlm")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("mikrosterlatih")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("mikrosbelumterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("sesuaisyarat")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("tdksesuaisyarat")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumcctdkdiketkompetensinya")}
                </td>
              </tr>
            </tbody>
          </>
        );
      default:
        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No.</th>
                <th rowSpan={2}>Tersedia crosschecker (CC)</th>
                <th rowSpan={2}>Nama petugas</th>
                <th rowSpan={2}>Kepegawaian</th>
                <th rowSpan={2}>NIP/ KTP</th>
                <th rowSpan={2}>Tgl lahir</th>
                <th rowSpan={2}>Pendidikan</th>
                <th rowSpan={2}>Tempat kerja</th>
                <th rowSpan={2}>Tgl mulai bekerja sebagai CC</th>
                <th rowSpan={2}>Ada SK?</th>
                <th rowSpan={2}>Juml pelatihan CC yang diikuti</th>
                <th colSpan={6} style={{ textAlign: "center" }}>
                  ToT mikroskopis malaria terakhir
                </th>
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Pelatihan terakhir
                </th>
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Bimtek/ tes panel terakhir
                </th>
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Uji profisiensi terakhir
                </th>
                <th colSpan={3} style={{ textAlign: "center" }}>
                  Uji kompetensi terakhir
                </th>
                <th rowSpan={2}>Memenuhi syarat sebagai CC malaria</th>
                <th rowSpan={2}>Kesimpulan</th>
              </tr>
              <tr>
                <th>Tanggal</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>
                <th>Tanggal</th>
                <th>Ada nilai?</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>
                <th>Tanggal</th>
                <th>Bimtek dg uji panel ?</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>
                <th>Tanggal</th>
                <th>Hasil</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>
                <th>Tanggal</th>
                <th>Hasil</th>
                <th>Keterangan nilai</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.sediamikroskopis}</td>
                    <td>{item?.namapetugas}</td>
                    <td>{item?.stspegawai}</td>
                    <td>{item?.nip}</td>
                    <td>
                      {item?.tlahir
                        ? moment(item?.tlahir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.pddkan}</td>
                    <td>{item?.tmpkerja}</td>
                    <td>
                      {item?.tglmulaikerja
                        ? moment(item?.tglmulaikerja).format("YYYY-MM-DD")
                        : "-"}
                    </td>

                    <td>{item?.sk}</td>
                    <td>{item?.jumplthan}</td>
                    <td>
                      {item?.tgltotmikros
                        ? moment(item?.tgltotmikros).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.hsltotsensi}</td>
                    <td>{item?.hsltotspesi}</td>
                    <td>{item?.hsltotakurasi}</td>
                    <td>{item?.hsltotparasit}</td>
                    <td>{item?.hsltot2}</td>
                    <td>
                      {item?.thnplthanakhir
                        ? moment(item?.thnplthanakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.nilaiplth}</td>
                    <td>{item?.hslplthsensi}</td>
                    <td>{item?.hslplthspesi}</td>
                    <td>{item?.hslplthakurasi}</td>
                    <td>{item?.hslplthhtungprst}</td>
                    <td>{item?.hslpelatihan2}</td>
                    <td>
                      {item?.tglbimtekakhir
                        ? moment(item?.tglbimtekakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.bimtekpanel}</td>
                    <td>{item?.hslbimteksensi}</td>
                    <td>{item?.hslbimtekspesi}</td>
                    <td>{item?.hslbimtekakurasi}</td>
                    <td>{item?.hslbimtekhtungprst}</td>
                    <td>{item?.hslbimtek2}</td>
                    <td>
                      {item?.tglujiprofis
                        ? moment(item?.tglujiprofis).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.hslujiprofis}</td>
                    <td>{item?.hslprofissensi}</td>
                    <td>{item?.hslprofisspesi}</td>
                    <td>{item?.hslprofisakurasi}</td>
                    <td>{item?.hslprofisparasit}</td>
                    <td>{item?.hslujiprofis2}</td>
                    <td>
                      {item?.tglujikompakhir
                        ? moment(item?.tglujikompakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.hslujikompakhir}</td>
                    <td>{item?.hslujikompakhir2}</td>
                    <td>{item?.cc_sesuai_syarat}</td>
                    <td>{item?.kesimpulan}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={34}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if (currentLevel === UserLevel.Province) {
    levelName = "Provinsi";
  } else if (currentLevel === UserLevel.District) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>SISMAL v4, Laporan Crosscheck Provinsi</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
            </th>
          </tr>
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
